import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Scrollbars from 'react-custom-scrollbars';
import { mergeStyles } from 'wix-rich-content-common';
import JoyPixelsIcon from '../icons/JoyPixelsIcon.js';
import getGroupEmojis from '../utils/getGroupEmojis.js';
import { getEmojiGroups } from '../constants.js';
import { ModalCloseButton } from 'wix-rich-content-ui-components';
import '../utils/convertUnicodeToEmoji.js';
import '../utils/emojiList.js';
import '../icons/FaBell.js';
import '../icons/FaFlag.js';
import '../icons/FaHeart.js';
import '../icons/FaPaw.js';
import '../icons/FaSmile.js';
import '../icons/FaPlane.js';
import '../icons/FaUtensils.js';
import '../icons/FaRegFutbol.js';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".ToIZc{display:flex;flex-direction:row;justify-content:space-between}[dir] .ToIZc{padding-bottom:10px;padding-top:10px}[dir=ltr] .ToIZc{padding-left:21px;padding-right:23px}[dir=rtl] .ToIZc{padding-left:23px;padding-right:21px}.cwUz8{color:#bdbdbd;font-size:16px}[dir] .cwUz8{cursor:pointer;padding:0 5px}._2ZnsJ:hover{opacity:.5}._0OZc4{display:inline-block}.yk9ss{box-sizing:border-box;font-size:20px;height:37px;width:37px}[dir] .yk9ss{cursor:pointer;margin:3px;padding:5px;text-align:center}[dir=ltr] .yk9ss{float:left}[dir=rtl] .yk9ss{float:right}[dir] .yk9ss:hover{background:#efefef}.u2qXT{color:var(--ricos-settings-text-color,#000);display:flex;font-size:14px;font-weight:300;justify-content:space-between}[dir] .u2qXT{margin-bottom:11px}[dir=ltr] .u2qXT{padding-left:17px;padding-right:17px}[dir=rtl] .u2qXT{padding-left:17px;padding-right:17px}.dBwAY{font-family:cursive!important;height:265px;min-width:272px;width:calc(100% - 12px)}[dir=ltr] .dBwAY{margin-left:6px}[dir=rtl] .dBwAY{margin-right:6px}._6dE16{color:rgba(0,0,0,.4);height:14px;width:auto}[dir] ._6dE16{padding-top:3px}.y4nqH{width:4px}[dir] .y4nqH{background:#b2b2b2;border-radius:4px;cursor:pointer}[dir=ltr] .y4nqH{margin-left:1px}[dir=rtl] .y4nqH{margin-right:1px}[dir] .y4nqH:hover{background:#000}";
var styles = {"emojiPreviewModal_emoji_icons_container":"ToIZc","emojiPreviewModal_nav_icon":"cwUz8","emojiPreviewModal_emoji_icon":"_2ZnsJ","emojiPreviewModal_emoji_group":"_0OZc4","emojiPreviewModal_emoji":"yk9ss","emojiPreviewModal_headerTitle":"u2qXT","emojiPreviewModal_emojis_groups_container":"dBwAY","emojiPreviewModal_JoyPixelsIcon":"_6dE16","emojiPreviewModal_scrollbar_thumb":"y4nqH"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class EmojiPreviewModal extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "onNavIconClicked", (group) => {
      this.setState({ activeGroup: group });
      this.groupRefs[group.category].current.scrollIntoView({
        behavior: "smooth"
      });
    });
    __publicField(this, "renderNavIcons", (activeGroup) => {
      const { t } = this.props;
      return getEmojiGroups(t).map((group, index) => {
        const color = activeGroup.category === group.category ? "#42A5F5" : "#bdbdbd";
        return /* @__PURE__ */ React.createElement(
          "div",
          {
            key: `emoji-group-${index}`,
            role: "button",
            "data-hook": "emoji-group-" + index,
            onKeyPress: null,
            tabIndex: 0,
            className: this.styles.emojiPreviewModal_nav_icon,
            onClick: this.onNavIconClicked.bind(this, group),
            style: { color }
          },
          group.icon
        );
      });
    });
    __publicField(this, "onScroll", (event) => {
      const { scrollTop } = event.srcElement;
      const { t } = this.props;
      const categoryScrollTop = getEmojiGroups(t).find(({ top }) => scrollTop < top);
      this.setState({ activeGroup: categoryScrollTop });
    });
    __publicField(this, "renderEmojis", () => this.emojiGroupsCategories.map((category) => {
      const emojis = getGroupEmojis(category) || [];
      const emojisElements = emojis.map((emoji, index) => /* @__PURE__ */ React.createElement(
        "div",
        {
          role: "button",
          "data-hook": "emoji-" + index,
          tabIndex: 0,
          className: this.styles.emojiPreviewModal_emoji,
          key: `emojis-${category}-${index}`,
          onClick: this.getBoundOnClick(emoji),
          onKeyPress: this.getBoundKeyPress(emoji)
        },
        emoji
      ));
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          ref: this.groupRefs[category],
          key: `anchor-${category}`,
          className: this.styles.emojiPreviewModal_emoji_group
        },
        emojisElements
      );
    }));
    this.styles = mergeStyles({ styles, theme: props.theme });
    const { t } = props;
    this.scrollbarRef = "";
    const groups = getEmojiGroups(t);
    this.groupRefs = {};
    groups.map(({ category }) => this.groupRefs[category] = React.createRef());
    this.emojiGroupsCategories = groups.map(({ category }) => category);
    this.state = {
      activeGroup: groups[0]
    };
  }
  getBoundOnClick(emoji) {
    return () => this.addEmoji(emoji);
  }
  getBoundKeyPress(emoji) {
    return (e) => {
      if (e.key === "Enter") {
        this.addEmoji(emoji);
      }
    };
  }
  addEmoji(emoji) {
    this.props.onAdd(emoji);
  }
  render() {
    const { activeGroup } = this.state;
    const { showCloseButton, closeModal } = this.props;
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: this.styles.emojiPreviewModal_headerTitle }, /* @__PURE__ */ React.createElement("div", null, activeGroup.title), /* @__PURE__ */ React.createElement("div", { className: this.styles.emojiPreviewModal_JoyPixelsIcon }, /* @__PURE__ */ React.createElement(JoyPixelsIcon, null)), showCloseButton && /* @__PURE__ */ React.createElement(ModalCloseButton, { closeModal })), /* @__PURE__ */ React.createElement("div", { className: this.styles.emojiPreviewModal_emojis_groups_container }, /* @__PURE__ */ React.createElement(
      Scrollbars,
      {
        ref: (ref) => {
          this.scrollbarRef = ref;
        },
        renderThumbVertical: () => /* @__PURE__ */ React.createElement("div", { className: this.styles.emojiPreviewModal_scrollbar_thumb }),
        onScroll: this.onScroll
      },
      this.renderEmojis()
    )), /* @__PURE__ */ React.createElement("div", { className: this.styles.emojiPreviewModal_emoji_icons_container }, this.renderNavIcons(activeGroup)));
  }
}
EmojiPreviewModal.propTypes = {
  theme: PropTypes.object.isRequired,
  t: PropTypes.func,
  onAdd: PropTypes.func,
  showCloseButton: PropTypes.bool,
  closeModal: PropTypes.func
};

export { EmojiPreviewModal as default };
//# sourceMappingURL=emojiPreviewModal.js.map
